// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1oYrD","modalForm":"UpgradeEpcsModal_modalForm__3pbRj","modalFooter":"UpgradeEpcsModal_modalFooter__5M_8F"};